;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      payment_id: null,
      retries: null,
      con_secret: null,
      con_key: null
    };
  },
  created: function created() {
    this.payment_id = this.$attrs["payment_id"];
    this.retries = this.$attrs["retries"];
    this.con_secret = this.$attrs["con_secret"];
    this.con_key = this.$attrs["con_key"];
  },


  methods: {
    execute: function execute() {
      var _this = this;

      _sweetalert2.default.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, reset transaction - " + this.payment_id
      }).then(function (result) {
        if (result.value) {
          _this.proceed();
        }
      });
    },
    proceed: function proceed() {
      var _this2 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.con_secret,
        key: this.con_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.reset_payment(response.data.token);
      }).catch(function (error) {
        _this2.error_message();
      }).then(function () {});
    },
    reset_payment: function reset_payment(token) {
      var _this3 = this;

      var new_retry = parseInt(this.retries) - 1;
      var api = "/api/payment/reset";
      var payload = {
        id: this.payment_id
      };
      Vue.axios.post(api, payload).then(function (response) {
        _this3.success_message();
        window.top.location.href = "/payments?advanced_search[q]=&advanced_search[status]=processing";
      }).catch(function (error) {
        _this3.error_message();
      }).then(function () {});
    },

    success_message: function success_message() {
      _sweetalert2.default.fire({
        title: "Message",
        text: "Request was successful",
        icon: "success"
      });
    },

    error_message: function error_message() {
      _sweetalert2.default.fire({
        title: "Message",
        text: "Unable to process your request at the moment",
        icon: "error"
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.execute}},[_vm._v("Stalled, Retry ?")])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e12985f", __vue__options__)
  } else {
    hotAPI.reload("data-v-6e12985f", __vue__options__)
  }
})()}